import * as React from 'react';
import FloatingCompose from './FloatingCompose';
import composeStore from 'owa-mail-compose-store/lib/store/composeStore';
import { observer } from 'mobx-react';
import { areDisplayAdsEnabled } from 'owa-mail-ads-shared';

const styles = require('./FloatingCompose.scss');

@observer
export default class FloatingComposeContainer extends React.Component<{}, {}> {
    render() {
        return (
            <div
                className={
                    areDisplayAdsEnabled()
                        ? styles.floatingContainerWithAds
                        : styles.floatingContainerWithoutAds
                }>
                {[...composeStore.floatingViewStates.keys()].map(key => (
                    <FloatingCompose
                        key={key}
                        viewState={composeStore.floatingViewStates.get(key)}
                    />
                ))}
            </div>
        );
    }
}
